var map = {
	"./arbitrum": 401,
	"./arbitrum.json": 401,
	"./aurora": 402,
	"./aurora.json": 402,
	"./avax": 403,
	"./avax.json": 403,
	"./bsc": 404,
	"./bsc.json": 404,
	"./celo": 405,
	"./celo.json": 405,
	"./cronos": 406,
	"./cronos.json": 406,
	"./emerald": 407,
	"./emerald.json": 407,
	"./ethereum": 408,
	"./ethereum.json": 408,
	"./fantom": 409,
	"./fantom.json": 409,
	"./featured": 321,
	"./featured.json": 321,
	"./fuse": 410,
	"./fuse.json": 410,
	"./harmony": 411,
	"./harmony.json": 411,
	"./heco": 412,
	"./heco.json": 412,
	"./kava": 413,
	"./kava.json": 413,
	"./metis": 414,
	"./metis.json": 414,
	"./moonbeam": 415,
	"./moonbeam.json": 415,
	"./moonriver": 416,
	"./moonriver.json": 416,
	"./optimism": 417,
	"./optimism.json": 417,
	"./polygon": 418,
	"./polygon.json": 418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 688;